import React from 'react';
import styled from '@emotion/styled';

import { AuthorNameLight, Avatar, LocalizedLink as LocalizedLinkBase } from '~/src/components';
import { breakpoints, fontWeight } from '~/src/styles';

const TeacherContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Link = styled(LocalizedLinkBase)`
  font-size: 12px;
  font-weight: ${fontWeight.regular};
  line-height: 25px;
  letter-spacing: 0.03em;
  color: white;
  ${breakpoints.minDesktop} {
    font-size: 16px;
  }
`;

interface Props {
  teacher: {
    image?: { processed_url: string };
    url_title: string;
    full_name: string;
  };
}

export const TeacherLink: React.FC<Props> = ({ teacher }) => {
  return (
    <TeacherContainer>
      <Avatar
        imgProps={{ role: 'presentation' }}
        style={{ display: 'inline-flex' }}
        src={teacher?.image?.processed_url}
      />
      <AuthorNameLight style={{ verticalAlign: 'super' }}>
        {teacher && <Link to={`/profile/${teacher.url_title}`}>{teacher.full_name}</Link>}
      </AuthorNameLight>
    </TeacherContainer>
  );
};
